import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff',
    position: 'absolute',
    paddingTop: '20%',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    textAlign: 'center',
    '& div': {
      marginTop: '2em',
    },
  },
}));

const LoadingPage = ({ text, hideSpinner }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {!hideSpinner && <CircularProgress />}
      <div>{text}</div>
    </div>
  );
};

export default LoadingPage;
